import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function usePeakHoursKpiTable({
  start_month,
  end_month,
  zones,
  collections,
  enable = true,
}) {
  const { getPeakHoursKpiTableData } = useApi();
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["peakHoursKpiTable", start_month, end_month, zones, collections],
    queryFn: () =>
      getPeakHoursKpiTableData({
        start_month,
        end_month,
        zones,
        collections,
      }),
    enabled: Boolean(enable),
  });

  return {
    data: data?.data,
    isLoading,
    isError,
    refetch,
  };
}
